<template>
  <div class="lp-input-text-container">
    <span v-if="required" style="position:absolute; left:-10px;">*</span>
    <label v-if="!!label" class="lp-input-text-label" for="" :style="labelStyle">{{ label }}</label>
    <input class="lp-input-text-input" :style="inputStyle" @keyup.enter="$emit('onEnter', value)"
           @keyup="$emit('onKeyup', value)" :readonly="disabled===true" :maxlength="maxlength"
           :type="type===undefined?'text':type" :placeholder="placeholder" v-model="value">
    <div v-if="!!fixedText" :style="textStyle" class="lp-input-fixed-text">{{ fixedText }}</div>
    <!-- v-validate="{ required: true, email: true, regex: /[0-9]+/ }" -->
    <!-- <span class="lp-input-text-validate" v-show="errors.has('email')">{{ errors.first('email') }}</span> -->
  </div>
</template>

<script>
  export default {
    props: [
      'data', 'label', 'placeholder', 'labelColor', 'type',
      'inputWidth', 'inputHeight', 'inputColor',
      'inputFontSize', 'inputFontWeight', 'borderBottom',
      'inputMargin', 'inputMinWidth', 'bgColor', 'inputBorder',
      'block', 'validType', 'fixedText', 'borderRadius',
      'inputAlign', 'inputPadding', 'disabled',
      'textTop', 'textRight', 'maxlength', 'required'
    ],
    data() {
      return {
        value: ''
      }
    },
    created() {
      this.value = this.data;
    },
    watch: {
      value(n) {
        this.$emit('update:data', n);
      },
      data(n) {
        if(this.type && this.type==='number' && this.maxlength){
          if(this.value.length > parseInt(this.maxlength)){
            this.value = this.value.substring(0, parseInt(this.maxlength));
          }
        }
        else
          this.value = n;
      }
    },
    computed: {
      inputStyle() {
        let style = {};

        if ( this.inputWidth !== undefined ) {
          style.width = this.inputWidth;
        }
        if ( this.block !== undefined ) {
          style.display = this.block;
        }
        if ( this.inputAlign !== undefined ) {
          style.textAlign = this.inputAlign;
        }
        if ( this.inputPadding !== undefined ) {
          style.padding = this.inputPadding;
        }
        if ( this.inputHeight !== undefined ) {
          style.height = this.inputHeight;
        }
        if ( this.inputFontSize !== undefined ) {
          style.fontSize = this.inputFontSize;
        }
        if ( this.inputFontWeight !== undefined ) {
          style.fontWeight = this.inputFontWeight;
        }
        if ( this.inputColor !== undefined ) {
          style.color = this.inputColor;
        }
        if( this.inputBorder !== undefined ) {
          style.border = this.inputBorder;
        }
        if ( this.borderBottom !== undefined ) {
          style.borderBottom = this.borderBottom;
        }
        if ( this.borderRadius !== undefined ) {
          style.borderRadius = this.borderRadius;
        }
        if ( this.bgColor !== undefined ) {
          style.backgroundColor = this.bgColor;
        }
        if ( this.inputMargin !== undefined ) {
          style.margin = this.inputMargin;
        }
        if ( this.inputMinWidth !== undefined ) {
          style.minWidth = this.inputMinWidth;
        }


        return style;
      },
      labelStyle() {
        let style = {};

        if ( this.labelWidth !== undefined ) {
          style.width = this.labelWidth;
        }
        if ( this.block !== undefined ) {
          style.display = this.block;
        }

        return style;
      },
      textStyle() {
        let style = {};

        if ( this.textTop !== undefined ) {
          style.top = this.textTop;
          if(this.label!== '') {
            style.top = `${parseInt(this.textTop.replace('px','')) + 26}px`;
          }

        }
        if ( this.textRight !== undefined ) {
          style.right = this.textRight;
        }

        return style;
      }
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>
  //@import '~assets/css/lp_main'
  @import '~assets/css/lp_variable'

  .lp-input-text-container
    position relative

  .lp-input-text-label
    margin-bottom 8px
    margin-right 8px
    display block
    color $font
    font-weight bold
    font-size 0.83rem

  .lp-input-text-input
    padding 8px 12px
    font-size .85rem
    color $font
    border-radius 3px
    background-color #ffffff
    border 1px solid $warmgrey
    display block

  // .lp-input-text-validate
  //   font-size 0.7rem
  //   color red
  //   position absolute
  //   bottom -4px
  //   left 112px

  .lp-input-fixed-text
    position absolute
    top 4px         // default
    right -20px     // default
    font-size .9rem
    color #666
</style>
